import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { ResourceCategory } from '../../entities';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class ResourceCategoryService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly resourceCategoryBaseUrl:string = `${Settings.apiUrl}/v1/ResourceCategories`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  public goalCategories:ResourceCategory[] = [];

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getResourceCategories(): Promise<ResourceCategory[]> {

    let oDataBuilder: ODataBuilder = new ODataBuilder(ResourceCategoryService.resourceCategoryBaseUrl);

    oDataBuilder
      .orderBy("SortOrder");

    let resourceCategoryUrl: string = oDataBuilder.toString();

    return this.http.get(resourceCategoryUrl)
      .toPromise()
      .then(response => {
        return response.json().value;
      });

  }

  createResourceCategory(resourceCategory: ResourceCategory): Promise<ResourceCategory> {   
    // must remove - breaks deserialization on the server when trying to convert empty string to Guid 
    delete resourceCategory.ResourceCategoryId;

    return this.http.post(ResourceCategoryService.resourceCategoryBaseUrl, JSON.stringify(resourceCategory), this.options)
      .toPromise()
      .then(response => {
        return response.json();
      });
  }

  patchResourceCategory(resourceCategory: ResourceCategory): Promise<null> {

    let resourceCategoryUrl: string = `${Settings.apiUrl}/v1/ResourceCategories(${resourceCategory.ResourceCategoryId})`;

    return this.http.patch(resourceCategoryUrl, JSON.stringify(resourceCategory), this.options)
      .toPromise()
      .then(response => response);
  }

} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/resource-category.service.ts